import { render, staticRenderFns } from "./Multi.vue?vue&type=template&id=601d63f2&scoped=true&"
import script from "./Multi.vue?vue&type=script&lang=js&"
export * from "./Multi.vue?vue&type=script&lang=js&"
import style0 from "./Multi.vue?vue&type=style&index=0&id=601d63f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d63f2",
  null
  
)

export default component.exports